import { render } from "./MonitoraggioSpeditivoForm.vue?vue&type=template&id=dbdf67fc"
import script from "./MonitoraggioSpeditivoForm.vue?vue&type=script&lang=js"
export * from "./MonitoraggioSpeditivoForm.vue?vue&type=script&lang=js"

import "./MonitoraggioSpeditivoForm.vue?vue&type=style&index=0&id=dbdf67fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__